import React from 'react';
import PropTypes from 'prop-types';

const TextError = ({ text, style }) => {
  return <div className={`text-[13px] text-danger ${style}`}>{text}</div>;
};

TextError.propTypes = {
  text: PropTypes.string.isRequired,
  style: PropTypes.string,
};

TextError.defaultProps = {
  style: ''
};

export default TextError;
